import { TwoDaysConsumeAreaChartWidget } from "../../Widgets/TwoDaysConsumeAreaChartWidget";

export const Practice = () => {
  return (
    <div style={{backgroundColor: 'purple', width: '300px', height: '200px'}}>
        <TwoDaysConsumeAreaChartWidget />
    </div>
  )
}